// helix-exception: Helix has no semantic token for these hues (Figma needs-input orange, highlight yellow/amber, categorical teal/cyan); primitive ramps with the identical colour are used (F-11)
/**
 * Pill sm: 20px tall, 2/6 padding, 6px radius. Its 1px stroke sits inside the box, so it is an
 * inset ring rather than a border, which would add 2px to the height and width. The border colour
 * is set to the stroke colour too, so the pill reports the stroke it draws.
 */
export const PILL_SHELL_CLASS =
  'inline-flex h-5 shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-sm border-0 px-1.5 py-0.5 text-xs font-medium leading-4 inset-ring'

export const WARNING_PILL_TONE_CLASS =
  'border-orange-300 dark:border-orange-700 bg-warning-50 dark:bg-gray-900 text-orange-700 dark:text-orange-200 inset-ring-orange-300 dark:inset-ring-orange-700'
